import { Component, ViewChild, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DocumentsDTO } from 'src/app/dtos/DocumentsDTO';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { NgZone } from '@angular/core';
import { BugModuleService } from 'src/app/services/bug-module/bug-module.service';
import { BugReportDTO } from 'src/app/dtos/BugReportDTO';
import { ToastrService } from 'ngx-toastr';
import { NgForm } from '@angular/forms';
import { DocumentsService } from 'src/app/services/documentsOperation/documents-service.service';
import { DocumentEnum } from '../../../../app/services/documentsOperation/DocumentEnum';
import { observableToPromise } from 'src/app/services/ObservableToPromise';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { S3ServiceService } from 'src/app/services/s3Service/s3-service.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import{OkayDialogboxComponent} from './okay-dialogbox/okay-dialogbox.component'
@Component({
  selector: 'app-report-bug',
  templateUrl: './report-bug.component.html',
  styleUrls: ['./report-bug.component.scss'],
})
export class ReportBugComponent implements OnInit {
  isSpinner: boolean = true;
  issueArray: string[] = ['Bug', 'Enhancement'];
  selectedIssue: string = this.issueArray[1];
  submitButton: string = "Submit";
  shortSummary: string = '';
  descriptiveSummary: string = '';
  shortSummaryValidation = false;
  descriptiveSummaryValidation = false;
  photo: any;
  isLoading:boolean=false;
  binaryImgString: string;
  base64textString: any;
  imageError: string;
  uploadImageTxt: string = 'Upload Image';
  formData: any;
  photos: { fileUrl: SafeResourceUrl, fileType: string, fileObj: File }[] = [];
  userId;


  @ViewChild('autosize') autosize!: CdkTextareaAutosize;
  @ViewChild('bugForm') bugForm!: NgForm;
  @ViewChild('fileInput') fileInput: any;


  constructor(
    private _ngZone: NgZone,
    public bugmoduleservice: BugModuleService,
    private toast: ToastrService,
    private documentService:DocumentsService,
    private s3Service: S3ServiceService,
    private sanitizer: DomSanitizer,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.getUser();
  }

  getUser(){
  this.bugmoduleservice.getUserId().subscribe(
    (res)=>{
      this.userId=res.body.userid;
    }
  )
  }
  async Submit() {
    this.submitButton="Submiting";
    this.isLoading=true;
    const bugReport = new BugReportDTO();
    bugReport.selectedIssue = this.selectedIssue;
    bugReport.shortSummary = this.shortSummary;
    bugReport.descriptiveSummary = this.descriptiveSummary;
    bugReport.photo = await this.uploadFile(this.photos);
    
    this.bugmoduleservice.addIssue(bugReport).subscribe({
      next: (res) => {
        this.toast.success(this.selectedIssue + ' reported successfully!', 'Success');
        this.resetForm();
        this.photos = [];
        this.submitButton="Submited";
        this.isLoading=false;
        this.okayDialog(this.selectedIssue);
      },
      error: (err) => {
        console.error('Error occurred while reporting issue:', err);
        this.toast.error('Failed to report ' + this.selectedIssue + '. Please try again.', 'Error');

        // Optional: handle specific error types if backend sends meaningful error messages
        if (err.error?.message?.includes('Failed to save bug')) {
          this.toast.error('Database error occurred. Contact admin.', 'Save Error');
        } else if (err.error?.message?.includes('Failed to send acknowledgment')) {
          this.toast.error('Bug saved, but mail failed to send.', 'Mail Error');
        }

        this.submitButton="Submited";
      }
    });


  }

okayDialog(selectedIssue: string)
{
   const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '350px';
    dialogConfig.height = '200px';
    dialogConfig.data = selectedIssue;
  
    dialogConfig.panelClass = 'activate-employee';
  
    const dialogRef = this.dialog.open(OkayDialogboxComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(() => {});
}

  resetForm() {
    this.bugForm.resetForm(); // Angular's template-driven form reset

    // Clear variables
    this.selectedIssue = this.issueArray[1];
    this.shortSummary = '';
    this.descriptiveSummary = '';
    this.photo = '';
    this.imageError = '';
    this.submitButton = 'Report'; // reset button text if needed

  }
  ngAfterViewInit() {
    this.triggerResize();
  }
  triggerResize() {
    this._ngZone.run(() => {
      setTimeout(() => {
        this.autosize.resizeToFitContent(true);
      }, 0);
    });
  }
  get shortSummaryWordCount(): number {
    return this.shortSummary ? this.shortSummary.trim().split(/\s+/).filter(w => w.length > 0).length : 0;
  }

  // Getter to count words in Descriptive Summary
  get descriptiveSummaryWordCount(): number {
    return this.descriptiveSummary ? this.descriptiveSummary.trim().split(/\s+/).filter(w => w.length > 0).length : 0;
  }

  // Function to enforce word limits dynamically
  enforceWordLimit(field: 'short' | 'long', event: Event): void {
    const inputField = event.target as HTMLInputElement;
    const words = inputField.value.split(/\s+/).filter(word => word.length > 0);

    if (field === 'short' && words.length > 15) {
      this.shortSummary = words.slice(0, 15).join(' '); // Keep only 15 words
    } else if (field === 'long' && words.length > 500) {
      this.descriptiveSummary = words.slice(0, 500).join(' '); // Keep only 500 words
    }
  }

  submitForm() {
    this.shortSummaryValidation = !this.shortSummary;
    this.descriptiveSummaryValidation = !this.descriptiveSummary;

    if (!this.shortSummary || !this.descriptiveSummary) {
      return;
    }

    this.Submit();
  }
  readMultipleFiles(files: FileList | null): void {
    this.imageError = '';
    this.uploadImageTxt = 'Uploading';

    if (!files || files.length === 0) {
      this.imageError = 'No files selected';
      this.uploadImageTxt = 'Upload';
      return;
    }
    // Limit to max 3 files total
    if (this.photos.length + files.length > 3) {
      this.imageError = 'You can only upload up to 3 images.';
      return;
    }

    for (let i = 0; i < files.length; i++) {
      const fileObj = files[i];
      const fileUrl = URL.createObjectURL(fileObj);
      const sanitizedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(fileUrl);
      const fileType = fileObj.type;

      if (fileType !== 'image/jpeg' && fileType !== 'image/png'&& fileType !== 'image/jpg') {
        this.imageError = 'Only JPEG,JPG,PNG files are allowed.';
        continue;
      }

      this.photos.push({ fileUrl:sanitizedUrl, fileType, fileObj });
    }
    this.uploadImageTxt = 'Re-Upload';
    this.fileInput.nativeElement.value = '';
  }

  removeImage(index: number): void {
    this.photos.splice(index, 1);
    this.uploadImageTxt = "Upload"
  }

  setDefaultImg() {
    this.photos = [];
    this.uploadImageTxt = 'Upload Image';
    this.imageError = '';
    this.fileInput.nativeElement.value = '';
  }

  async uploadFile(photoData)
  {
    let photoName=await this.assignPhotos(photoData);
    let docId=[];
    for (let i=0;i<photoData.length;i++)
    {
      try
      {
        let fileName=`${photoName[i][1]}.${photoData[i].fileType.split('/')[1]}`
        const res = await observableToPromise(this.s3Service.getPutPresignedUrl(fileName, DocumentEnum.ISSUE, photoData[i].fileType));
        let presignedUrl =res.body;
        if (!presignedUrl?.url) {
          console.error('Presigned URL not found');
          return;
        }
        try {
          await this.s3Service.uploadFileToS3(presignedUrl.url, photoData[i].fileObj);
          let receivedDocId= await this.uploadDocument(presignedUrl.objectKey, this.userId,photoData[i].fileType,fileName,fileName);
          docId.push(receivedDocId);
          
        } catch (err) {
          console.error('Error uploading file:', err);
          return null;
        }
      }
      catch (e) {
        console.error('Error in upload flow', e);
        return null;
      }
      
    }
     return docId;
  }
  uploadDocument(object: string, employeeId, extension, refactoredFileName, documentName): Promise<string> {
        const payload: DocumentsDTO = {
          user_id: employeeId,
          cloud_storage_path: object,
          documentType: DocumentEnum.ISSUE,
          file_extension: extension,
          document_name: refactoredFileName,
          document_number: documentName,
          modified_by: employeeId,
        };
          
          const observable = this.documentService.uploadDocument(payload);
    
        return new Promise((resolve, reject) => {
          observable.subscribe({
            next: (res) => resolve(res.body.body),
            error: (err) => reject(err)
          });
        });
    }

  async assignPhotos(photos): Promise<string[][]> {
    return new Promise((resolve, reject) => {
      this.documentService.getDocumentNumber(DocumentEnum.ISSUE).subscribe(
        (res) => {
          const count = res.body;
          const result: string[][] = [];

          for (let i in photos) {
            const photoName = `issue_${count}_${i}`;
            result.push([photos[i].fileObj, photoName]);
          }

          resolve(result);
        },
        (error) => {
          console.error('Error fetching document number:', error);
          reject(error);
        }
      );
    });
  }

}
